import { createReducer } from 'typesafe-actions';
import { LooksWishlistActionType, actions } from './actions';
import {
    LooksWishlistQueueState,
    LooksWishlistQueueActionTypes,
    LOOKS_WISHLIST_QUEUE_UPDATED,
    LooksWishlistState,
} from './types';
import { get } from 'Common/utils/objectUtils';

export const looksWishlistQueueReducer = (
    state: LooksWishlistQueueState = {
        todo: null,
        lookSlug: null,
    },
    action: LooksWishlistQueueActionTypes
): LooksWishlistQueueState => {
    if (action.type === LOOKS_WISHLIST_QUEUE_UPDATED) {
        return {
            ...state,
            todo: action.payload.todo,
            lookSlug: action.payload.lookSlug,
        };
    }
    return state;
};

export const looksWishlistDefaultState: LooksWishlistState = {
    isFetching: false,
    isFetched: false,
    didInvalidate: false,
    looks: [],
    count: 0,
};

export const looksWishlistReducer = createReducer<LooksWishlistState, LooksWishlistActionType>(
    looksWishlistDefaultState
)
    .handleAction(actions.isFetchingLooksWishlistAction, state => ({
        ...state,
        isFetching: true,
    }))
    .handleAction(actions.fetchLooksWishlistSuccessAction, (state, action) => {
        const looks = get(action.payload.response, 'data', []);
        return {
            ...state,
            isFetching: false,
            looks,
            isFetched: true,
            count: looks.length,
            didInvalidate: false,
        };
    })
    .handleAction(actions.fetchLooksWishlistFailedAction, (state, action) => ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.payload,
    }))
    .handleAction(actions.addToLooksWishlistFailedAction, (state, action) => {
        const newLooksSlugs = [...state.looks.filter(lookSlug => lookSlug !== action.payload.lookSlug)];
        return {
            ...state,
            isFetching: false,
            looks: newLooksSlugs,
            count: newLooksSlugs.length,
        };
    })
    .handleAction(actions.isRemovingFromLooksWishlistAction, (state, action) => {
        const newLooksSlugs = [...state.looks.filter(lookSlug => lookSlug !== action.payload.lookSlug)];
        return {
            ...state,
            isFetching: true,
            looks: newLooksSlugs,
            count: newLooksSlugs.length,
        };
    })
    .handleAction(actions.removeFromLooksWishlistSuccessAction, state => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
    }))
    .handleAction(actions.removeFromLooksWishlistFailedAction, (state, action) => {
        const newLooksSlugs = [action.payload.lookSlug, ...state.looks];
        return {
            ...state,
            isFetching: false,
            looks: newLooksSlugs,
            count: newLooksSlugs.length,
        };
    })
    .handleAction(actions.isAddingToLooksWishlistAction, (state, action) => {
        const newLooksSlugs = [action.payload.lookSlug, ...state.looks];
        return {
            ...state,
            isFetching: true,
            looks: newLooksSlugs,
            count: newLooksSlugs.length,
        };
    })
    .handleAction(actions.addToLooksWishlistSuccessAction, state => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
    }));

export default looksWishlistReducer;
